import { render } from "./ListaReunioes.vue?vue&type=template&id=1d7f988f&scoped=true"
import script from "./ListaReunioes.vue?vue&type=script&lang=js"
export * from "./ListaReunioes.vue?vue&type=script&lang=js"

import "./ListaReunioes.vue?vue&type=style&index=0&id=1d7f988f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d7f988f"]])

export default __exports__